// extracted by mini-css-extract-plugin
export default {"dropdownContainer":"F2WM_uGnzGk_7SK1","title":"lolniIqWpxQzQ0_U"};